(() => {
  function init() {
    document
      .querySelectorAll('slideshow-component[autoplay][infinite]')
      .forEach((ss) => {
        const scroller = ss.querySelector('slideshow-slides');

        if (!scroller || scroller.dataset.loopSwipe === '1') return;

        scroller.dataset.loopSwipe = '1';
        scroller.style.touchAction = 'pan-y';

        let startX = 0;
        let startY = 0;

        scroller.addEventListener('touchstart', (e) => {
          if (e.touches.length !== 1) return;

          startX = e.touches[0].clientX;
          startY = e.touches[0].clientY;
          ss.suspend?.();
        }, { passive: true });

        scroller.addEventListener('touchend', (e) => {
          const dx = e.changedTouches[0].clientX - startX;
          const dy = e.changedTouches[0].clientY - startY;

          if (Math.abs(dx) >= 35 && Math.abs(dx) > Math.abs(dy)) {
            if (dx < 0) ss.next?.();
            else ss.previous?.();
          }

          setTimeout(() => ss.resume?.(), 400);
        }, { passive: true });
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();